/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import Media from "./Media";

const LeftBanner = () => {
  const [text] = useTypewriter({
    words: [
      "Junior Software Engineer.",
      "Full Stack Developer.",
      "Competetive Programmer.",
      "CSE Engineer, JUST",
    ],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 2000,
  });

  return (
    <div className="w-full lgl:w-1/2 flex flex-col gap-20">
      <div className="flex flex-col gap-5">
        <h4 className=" text-lg font-normal" data-aos="fade-right">
          Hola Amingos 👀🙋‍♂️{" "}
        </h4>
        <h1 className="text-5xl font-bold text-white" data-aos="fade-right">
          Hi, I'm{" "}
          <span className="text-designColor capitalize">Md Shojib Hossain</span>
        </h1>
        <h2 className="text-3xl font-bold text-white" data-aos="fade-right">
          a <span>{text}</span>
          <Cursor
            cursorBlinking="false"
            cursorStyle="|"
            cursorColor="#ff014f"
          />
        </h2>
        <p
          className="text-base font-bodyFont leading-6 tracking-wide"
          data-aos="fade-right"
        >
          I am Md Shojib Hossain, a Junior Software Engineer passionate about building dynamic and user-friendly web applications. With a strong foundation in MongoDB, MySQL, Express.js, React, Node.js, and Laravel. I aim to contribute to a forward-thinking team where I can grow my skills and develop innovative solutions.
        </p>
      </div>
      {/* Media */}
      <Media />
    </div>
  );
};

export default LeftBanner;
